"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGroupedBlockType = exports.addHash = exports.getHash = exports.getTintBlendModeByLabel = exports.getBlockSpacingValue = exports.getSplashBlockMinHeightValue = exports.getBlockWidthValue = void 0;
var lodash_1 = require("lodash");
var object_hash_1 = __importDefault(require("object-hash"));
var blockSpacingMappings_1 = __importDefault(require("./BlockConfig/blockSpacingMappings"));
var blockWidthMappings_1 = __importDefault(require("./BlockConfig/blockWidthMappings"));
var commonTypes_1 = require("./BlockConfig/commonTypes");
var splashConfig_1 = require("./BlockConfig/splashConfig");
var BlockStyleTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/BlockStyleTypes");
var getBlockWidthValue = function (optionLabel) {
    if (optionLabel) {
        return blockWidthMappings_1.default[optionLabel];
    }
};
exports.getBlockWidthValue = getBlockWidthValue;
var getSplashBlockMinHeightValue = function (optionLabel) {
    if (optionLabel) {
        return splashConfig_1.minHeightOptions[optionLabel];
    }
};
exports.getSplashBlockMinHeightValue = getSplashBlockMinHeightValue;
var getBlockSpacingValue = function (optionLabel) {
    if (optionLabel) {
        return blockSpacingMappings_1.default[optionLabel];
    }
};
exports.getBlockSpacingValue = getBlockSpacingValue;
var getTintBlendModeByLabel = function (label) {
    var blendMode = splashConfig_1.tintBlendModeOptions.find(function (config) { return config.label === label; });
    return !!blendMode ? blendMode.value : "blend";
};
exports.getTintBlendModeByLabel = getTintBlendModeByLabel;
var getHash = function (style) {
    var firstHash = (0, object_hash_1.default)(clearEmptyObjects((0, lodash_1.cloneDeep)(style)), {
        algorithm: "sha1",
        excludeKeys: function (key) {
            return ["abs", "name", "hash", "_id", "clonedFrom", "preTcdcRef"].includes(key);
        },
    });
    if ((0, BlockStyleTypes_1.isSourceStyle)(style)) {
        return (0, object_hash_1.default)({
            first: firstHash,
            h1: undefined,
            h2: undefined,
            p: undefined,
            blockQuote: undefined,
        });
    }
    else {
        return (0, object_hash_1.default)({
            first: firstHash,
            h1: style.h1 && style.h1.size && style.h1.size.abs,
            h2: style.h2 && style.h2.size && style.h2.size.abs,
            p: style.p && style.p.size && style.p.size.abs,
            blockQuote: style.blockQuote && style.blockQuote.size.abs,
        });
    }
};
exports.getHash = getHash;
var addHash = function (style) {
    style.hash = (0, exports.getHash)(style);
    return style;
};
exports.addHash = addHash;
var getGroupedBlockType = function (blockType) {
    return [commonTypes_1.BlockType.Source, commonTypes_1.BlockType.Splash, commonTypes_1.BlockType.Accept, commonTypes_1.BlockType.Quote].includes(blockType)
        ? blockType
        : commonTypes_1.BlockType.Text;
};
exports.getGroupedBlockType = getGroupedBlockType;
var clearEmptyObjects = function (o) {
    for (var k in o) {
        if (!o[k] || typeof o[k] !== "object") {
            continue;
        }
        clearEmptyObjects(o[k]);
        if (Object.keys(o[k]).length === 0) {
            delete o[k];
        }
    }
    return o;
};
